import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { MoveoIcon } from '@/components/Icons/MoveoIcon';
import { ToastsWrapper as Toasts } from '@/newComponents/Toast/ToastWrapper';
import { showPoweredBySelector, themeSelector } from '@/state/config';
import styles from './ChatFooter.module.scss';
export const ChatFooter = ({ children }) => {
    const theme = useRecoilValue(themeSelector);
    const showPoweredBy = useRecoilValue(showPoweredBySelector);
    const { t } = useTranslation();
    return (_jsxs("div", { className: cn('relative flex flex-col items-end px-3 pb-4', styles[theme]), children: [_jsx(Toasts, {}), showPoweredBy && (_jsxs("span", { className: "bg-bg-muted text-foreground-muted dark:border-input absolute -top-[28px] z-0 flex w-[calc(100%-24px)] justify-end gap-1 rounded-t-xl border border-gray-200 pt-1.5 pr-4 pb-6 text-xs", children: ["Powered by ", _jsx(MoveoIcon, {}), _jsx("a", { className: cn('text-accent'), href: "https://moveo.ai?ref=web-client", target: "_blank", rel: "noreferrer", children: t('moveo_ai') })] })), children] }));
};
